export default {
  drawer: null,
  color: 'success',
  image: 'https://i.hurimg.com/i/hdn/75/0x0/5da6f8a50f254420341e14b8.jpg'
}
